// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__ekUog","label":"CategoryService_label__3BxBp","location":"CategoryService_location__28cBH"};